<!-- menu -->
<div class="hidden" *ngIf="exitPermissionCompany('personalhistoricals.view')" [ngClass]="btn_menuHistory === true ? 'show':''">
    <div>
        <div class="title-hidden">Historial de cambios</div>
        <span (click)="btn_menuHistory = !btn_menuHistory">X</span>
    </div>
    <app-select-search
        [appearance]="'outline'"
        [_dataSource]="listMenuHistory" [textInput]="'SERVICIO'" [dataShow]="'name'" [dataValue]="'id'" [siteCtrl]="controHistory"
        [inputType]="'text'" (onSelectionChange)="getHistory()">
    </app-select-search>
    <div class="history-scroll">
        <div class="history" *ngFor="let his of history">
            <div class="history-date"><mat-icon>play_arrow</mat-icon><div>{{fechasService.getDateFormatRWithHourAMPM(his.UpdateDate) || ''}}</div></div>
            <div class="history-user" *ngIf="his.Action"><mat-icon>circle</mat-icon><div>{{his.Action || ''}}</div></div>
            <div class="history-user" *ngIf="his.Module"><mat-icon>circle</mat-icon><div>Modulo {{(his.Module || '') | lowercase}}</div></div>
            <div class="history-user" *ngIf="his.ContractNumber"><div>Contratos:&nbsp;{{getContractNumber(his.ContractNumber) || ''}}</div></div>
            <div class="history-user" *ngIf="his.Position"><div>Función:&nbsp;{{his.Position || ''}}</div></div>
            <div class="history-user" *ngIf="his.StartDate"><div>Inicio de acceso:&nbsp;{{fechasService.getDateFormatRWithHourAMPM(his.StartDate) || ''}}</div></div>
            <div class="history-user" *ngIf="his.FinishDate"><div>Fin de acceso:&nbsp;{{fechasService.getDateFormatRWithHourAMPM(his.FinishDate) || ''}}</div></div>
            <div class="history-user"><mat-icon>circle</mat-icon><div>{{his.UserName || 'Sin user'}}</div></div>
        </div>
    </div>
</div>
<div class="btn-open-history" (click)="getHistory()" *ngIf="btn_menuHistory === false">
    <mat-icon>history</mat-icon>
</div>
<!-- fin menu historyu -->
<div class="btns-actions" *ngIf="!flagListF || !flagVeto">
  <div class="btn-save">
    <button mat-fab color="primary" *ngIf="flagChangeDataBtnSave && exitPermissionCompany('personals.update')"
            matTooltip="Guardar" type="button" (click)="eventSave()">
      <mat-icon>save</mat-icon>
    </button>

    <span *ngIf="flagChangeDataBtnSave && !exitPermissionCompany('personals.update')"
          matTooltip="Apagado porque no cuenta con el permiso"
          matTooltipPosition="above"
          style="display:inline-block">
      <button mat-fab color="secundary" type="button" disabled>
        <mat-icon>save</mat-icon>
      </button>
    </span>

    <button mat-fab color="secundary" *ngIf="!flagChangeDataBtnSave" type="button" disabled>
      <mat-icon>save</mat-icon>
    </button>
  </div>
</div>

<!-- ESTA ES LA TARJETA DE INFORMACION DEL EMPLEADO -->
<div class="contract-proyect" >
    <div class="box information-fields" *ngIf="configCard.typeCard === 'information'">
        <div class="header">
            <div class="content" [ngClass]="configCard.color || 'primary'">{{configCard.title || 'N/A'}}</div>
        </div>
        <div class="content-card" *ngIf="personal">
            <!-- TITLE AND PHOTO -->
          <div class="container-top-img" [class.request-photo-layout]="personal?.RequestPhotoChange === true || isPhotoQualityFailed === true">
            <mat-icon class="icon-blacklist-vetos" *ngIf="flagVeto === false && exitPermissionCompany('personalblacklistveto.view')" matTooltip="Agregar a la lista"
              [matTooltipPosition]="'right'" (click)="showPopupBlackList(flagBlackListFuture ? 'Desea modificar un veto?' : 'Desea crear un veto?', 'VETO')">
              stop
            </mat-icon>

            <mat-icon class="icon-blacklist-personal" *ngIf="flagVeto === true && exitPermissionCompany('personalblacklistveto.view')"
              [matTooltip]="setupTooltipVeto()" [matTooltipPosition]="'right'" matTooltipClass="testClassTootipBlackList" (click)="showPopupBlackList('Desea modificar un veto?', 'VETO')">
              stop
            </mat-icon>

            <mat-label class="title-Veto-list" *ngIf="flagVeto === true && exitPermissionCompany('personalblacklistveto.view')" (click)="showPopupBlackList('Desea modificar un veto?', 'VETO')">
              Sancionado
            </mat-label>

            <div class="img-container" [class.request-photo-change]="personal?.RequestPhotoChange === true || isPhotoQualityFailed === true">
              <div class="photo-wrapper">
                <img class="img-perfil" src="{{ s3Bucket + etImg(personal.Photo) }}" (error)="commonMetodService._getUrlErrorImg('personal', $event)" alt="">
                <a *ngIf="(flagListF === false || flagVeto === false) && (isPhotoChangeRequired() || exitPermissionCompany('personals.update'))"
                   class="btn-camera"
                   [class.btn-camera-disabled]="!canChangePhoto()"
                   [matTooltip]="!canChangePhoto() ? 'Apagado porque no cuenta con el permiso' : ''"
                   matTooltipPosition="above"
                   (click)="canChangePhoto() && openDialogPhotoPersonal()">
                  <mat-icon>camera_alt</mat-icon>
                </a>
                <a *ngIf="(flagListF === false || flagVeto === false) && exitPermissionCompany('personals.facetrace.view')"
                   class="btn-face-trace"
                   [ngClass]="{'photo-invalid-icon': personal?.RequestPhotoChange === true || isPhotoQualityFailed === true}"
                   (click)="openFaceTraceDialog()"
                   matTooltip="Historial y Trazabilidad Facial">
                  <mat-icon>manage_search</mat-icon>
                </a>
              </div>
            </div>

            <!-- Aviso 1: Solo requiere cambio de foto -->
            <div class="block-alert-container block-alert-static" *ngIf="(personal?.RequestPhotoChange === true || isPhotoQualityFailed === true) && sanctionedByExtraTime !== true && (flagListF === false || flagVeto === false)">
              <mat-icon class="block-alert-icon-photo">warning</mat-icon>
              <div class="block-alert-text">
                <span class="block-alert-title-photo">Se requiere cambiar la foto</span>
              </div>
            </div>

            <!-- Aviso 2: Bloqueado por horas extras no aprobadas (solo informativo, sin interaccion) -->
            <div class="block-alert-container block-alert-static" *ngIf="sanctionedByExtraTime === true && (flagListF === false || flagVeto === false)">
              <mat-icon class="block-alert-icon">warning</mat-icon>
              <div class="block-alert-text">
                <span class="block-alert-title">Bloqueado por horas extras no aprobadas</span>
                <span class="block-alert-subtitle" *ngIf="personal?.RequestPhotoChange === true || isPhotoQualityFailed === true">Se requiere cambiar la foto</span>
              </div>
            </div>

            <mat-icon class="icon-black-list-add" *ngIf="flagListF === false && exitPermissionCompany('personalblacklistsanction.view')" matTooltip="Agregar a la lista" [matTooltipPosition]="'right'"
              (click)="showPopupBlackList(flagBlackListFuture ? 'Desea modificar una sanción?' : 'Desea crear una sanción?', 'SANCTION')">
              person
            </mat-icon>

            <mat-icon class="icon-black-list-remove" *ngIf="flagListF === true && exitPermissionCompany('personalblacklistsanction.view')" [matTooltip]="setupTooltipBlackList()"
              [matTooltipPosition]="'right'" matTooltipClass="testClassTootipBlackList" (click)="showPopupBlackList('Desea modificar una sanción?', 'SANCTION')">
              person_off
            </mat-icon>

            <mat-label class="title-black-list" *ngIf="flagListF === true && exitPermissionCompany('personalblacklistsanction.view')"
              (click)="showPopupBlackList('Desea modificar una sanción?', 'SANCTION')">
              Sancionado
            </mat-label>
          </div>

          <div class="card-description">
                <form [formGroup]="formPersonal" autocomplete="off">
                    <app-select-search class="select-component"
                            [appearance]="'outline'"
                            [_dataSource]="nationality" [textInput]="'NACIONALIDAD'" [dataShow]="'Description'" [dataValue]="'Value'" [siteCtrl]="formPersonal.get('Nationality')"
                            [inputType]="'text'" (onSelectionChange)="getRequirementsUptadeInfo()">
                    </app-select-search>
                    <div class="fields-group">
                        <mat-form-field class="input-field-medium"  style="margin-left: 0px;" appearance="outline">
                            <label class="employee-information">TIPO</label>
                            <mat-select formControlName="DocumentType" [disabled]="isCreateAppPersonal" [compareWith]="compareDocumentType">
                                <mat-option *ngFor="let data of companyDocumentType" [value]="data.Value">
                                    {{data.Description}}
                                </mat-option>
                            </mat-select>
                            <mat-error>Requerido</mat-error>
                        </mat-form-field>
                        <mat-form-field class="input-field no-spinner" appearance="outline">
                          <label class="employee-information">NÚMERO</label>
                          <input *ngIf="IsSuperUser" matInput type="number" formControlName="DocumentNumber" [disabled]="isCreateAppPersonal"
                                 onkeypress="return (event.charCode >= 48 && event.charCode <= 57)">
                          <input *ngIf="!IsSuperUser" matInput type="number" [value]="formPersonal.get('DocumentNumber')?.value" disabled>
                          <mat-error>Requerido</mat-error>
                        </mat-form-field>

                    </div>
                    <mat-form-field class="input-field" appearance="outline">
                        <label class="employee-information">NOMBRE</label>
                        <input matInput type="text" formControlName="Name" (input)="convertirAMayusculas($event, formPersonal, 'Name')">
                        <mat-error>Requerido</mat-error>
                    </mat-form-field>
                    <mat-form-field class="input-field" appearance="outline">
                        <label class="employee-information">APELLIDOS</label>
                        <input matInput type="text" formControlName="LastName" (input)="convertirAMayusculas($event, formPersonal, 'LastName')">
                        <mat-error>Requerido</mat-error>
                    </mat-form-field>
                    <div class="fields-group">
                        <mat-form-field class="input-filed-fecha" style="margin-left: 0px;" appearance="outline">
                            <label class="employee-information">FECH. NACIMIENTO</label>
                            <input matInput [matDatepicker]="picker" formControlName="BirthDate" (click)="picker.open()" minlength="8" [readonly]="true"
                            (dateChange)="changeBirthDateCalculate()">
                            <mat-datepicker #picker></mat-datepicker>
                            <mat-error>Requerido</mat-error>
                        </mat-form-field>
                        <app-select-search class="select-field-medium-1"
                                [appearance]="'outline'"
                            [_dataSource]="sex" [textInput]="'SEXO'" [dataShow]="'Value'" [dataValue]="'Value'" [siteCtrl]="formPersonal.get('Sex')"
                            [inputType]="'text'">
                        </app-select-search>
                        <app-select-search class="select-field-medium-1"
                                [appearance]="'outline'"
                            [_dataSource]="rh" [textInput]="'RH'" [dataShow]="'Description'" [dataValue]="'Value'" [siteCtrl]="formPersonal.get('RH')"
                            [inputType]="'text'">
                        </app-select-search>
                    </div>
                    <app-select-search class="select-component-medium"
                            [appearance]="'outline'"
                            [_dataSource]="countrys" [textInput]="'PAIS DE NACIMIENTO'" [dataShow]="'Description'" [dataValue]="'Value'" [siteCtrl]="formPersonal.get('contryNalcionality')"
                            [inputType]="'text'" (onSelectionChange)="getCitiesNacimiento($event, true)">
                    </app-select-search>
                    <app-select-search
                            [appearance]="'outline'"
                        [_dataSource]="citiesNacimiento" [textInput]="'CIUDAD DE NACIMIENTO'" [dataShow]="'Name'" [dataValue]="'Code'" [siteCtrl]="formPersonal.get('CityOfBirthCode')"
                        [inputType]="'text'">
                    </app-select-search>
                    <div class="fields-group" *ngIf="exitPermissionCompany('personals.docexpeditionview')">
                        <mat-form-field class="input-filed-fecha" style="margin-left: 0px;" appearance="outline">
                            <label class="employee-information">FECH. DE EXPEDICIÓN</label>
                            <input matInput [matDatepicker]="pickerExpedicion"
                                #inputExpeditionDate
                                [value]="controlExpeditionDate.value" (click)="pickerExpedicion.open()" minlength="8" [readonly]="true"
                                (dateChange)="changeExpeditionDate(inputExpeditionDate.value)"
                                [disabled]="(flagListF === true || flagVeto === true)">
                            <mat-datepicker #pickerExpedicion></mat-datepicker>
                            <mat-error>Requerido</mat-error>
                        </mat-form-field>
                        <app-select-search class="select-medium-short"
                                           [appearance]="'outline'"
                                           [_dataSource]="citiesExpedicion" [textInput]="'LUGAR DE EXPEDICIÓN'" [dataShow]="'Name'" [dataValue]="'Code'" [siteCtrl]="controlExpeditionPlace"
                                           [inputType]="'text'" [disabled]="(flagListF === true || flagVeto === true)" (onSelectionChange)="changeControlExpeditionPlace()">
                        </app-select-search>
                    </div>
                    <!-- SUBTITLE 3 ITEMS -->
                    <div class="sub-header">
                        <div class="sub-content greendAnalityco">
                            {{'CONTACTO' || 'N/A'}}
                        </div>
                    </div>
                    <br>
                    <app-select-search class="select-component-medium"
                            [appearance]="'outline'"
                            [_dataSource]="daneCity" [textInput]="'CIUDAD'" [dataShow]="'CityName'" [dataValue]="'CityCode'" [siteCtrl]="formPersonal.get('CityCode')"
                            [inputType]="'text'" (onSelectionChange)="getTown($event)">
                    </app-select-search>
                    <!-- //direccion spla sin localidad porque base datos no esta el tiwnCode -->

                    <div class="fields-group">
                        <mat-form-field class="input-field-medium-more" style="margin-left: 0px;" appearance="outline">
                            <label class="employee-information">DIRECCIÓN</label>
                            <input matInput type="text" formControlName="Address">
                            <mat-error>Requerido</mat-error>
                    </mat-form-field>
                        <app-select-search class="select-field-medium-short"
                                [appearance]="'outline'"
                            [_dataSource]="town" [textInput]="'ZONA O LOCALIDAD'" [dataShow]="'Name'" [dataValue]="'Id'" [siteCtrl]="formPersonal.get('TownId')"
                            [inputType]="'text'">
                        </app-select-search>
                    </div>
                    <div class="fields-group">
                        <mat-form-field class="input-field-medium-more" style="margin-left: 0px;" appearance="outline">
                            <label class="employee-information">CORREO</label>
                            <input matInput type="text" formControlName="Email" (input)="convertirAMinusculas($event, formPersonal, 'Email')">
                            <mat-error>formato incorrecto / Requerido</mat-error>
                        </mat-form-field>
                        <mat-form-field class="field-short" appearance="outline">
                            <label class="employee-information">TELEFONO</label>
                            <input matInput type="text" formControlName="PhoneNumber">
                            <mat-error>Requerido</mat-error>
                        </mat-form-field>
                    </div>
                    <app-select-search class="select-component-medium"
                        [appearance]="'outline'"
                        [_dataSource]="eps" [textInput]="'EPS'" [dataShow]="'Name'" [dataValue]="'Id'" [siteCtrl]="formPersonal.get('EpsId')"
                        [inputType]="'text'" (onSelectionChange)="changeEPSAFP($event, 'EPS')">
                    </app-select-search>
                    <app-select-search class="select-component-medium"
                        [appearance]="'outline'"
                        [_dataSource]="afp" [textInput]="'AFP'" [dataShow]="'Name'" [dataValue]="'Id'" [siteCtrl]="formPersonal.get('AfpId')"
                        [inputType]="'text'" (onSelectionChange)="changeEPSAFP($event, 'AFP')">
                    </app-select-search>
                    <div class="subTitle">En caso de emergencia llamar a</div>
                    <div class="fields-group">
                        <mat-form-field class="input-field-medium-more" appearance="outline">
                            <label class="employee-information">NOMBRE</label>
                            <input matInput type="text" formControlName="EmergencyContact">
                            <mat-error>Requerido</mat-error>
                        </mat-form-field>
                        <mat-form-field class="input-field-medium-short" appearance="outline">
                            <label class="employee-information">PARENTESCO</label>
                            <input matInput type="text" formControlName="RelationshipWithContact">
                            <mat-error>Requerido</mat-error>
                        </mat-form-field>
                    </div>
                    <div class="fields-group">
                        <mat-form-field class="input-field-51" appearance="outline">
                            <label class="employee-information">TELEFONO</label>
                            <input matInput type="text" formControlName="EmergencyContactPhone">
                            <mat-error>Requerido</mat-error>
                        </mat-form-field>
                    </div>
                </form>
            </div>
        </div>
        <div class="content-card list-card pre-content" *ngIf="!personal">
            <div class="form-group-list" *ngFor="let item of production.pre_loading">
                <div class="card">
                    <div class="relational-info">
                        <div class="desc flex" style="width: 18px;">
                            <div class="icon-pre pre-loading"></div>
                            <div class="title-pre pre-loading"></div>
                        </div>
                        <div class="icon-pre pre-loading"></div>
                    </div>
                    <div class="card-content">
                        <div class="pre-img pre-loading"></div>
                        <div class="content-information">
                            <div class="text-pre pre-loading"></div>
                            <div class="text-pre pre-loading"></div>
                            <div class="text-pre pre-loading"></div>
                        </div>
                    </div>
                </div>
                <hr>
            </div>
        </div>
    </div>

  <!-- OTROS DATOS HOJA DE VIDA -->
  <div>
    <div class="box information-fields" *ngIf="configCard.typeCard === 'information' && exitPermissionCompany('personalanotherdata.view')">
      <div class="header">
        <div class="content" [ngClass]="'greendAnalityco'">{{'OTROS DATOS' || 'N/A'}}</div>
      </div>
      <div class="content-card">
        <form [formGroup]="formPersonalCV" class="docsCV" autocomplete="off">
          <div class="item-list-docs">
            <div class="subTitle">Hoja de vida</div>
            <div class="doc-name" *ngIf="exitPermissionCompany('personalstudiescert.view')">
              <svg *ngIf="(formDataStudyCertificate !== undefined && formDataStudyCertificate !== null) || (urlDataStudyCertificate !== null && urlDataStudyCertificate !== '')"
                   (click)="openDocumentsPersonalCV('StudyCertificate')"
                   title="EPS" style="fill: #4C4C4C" class="req-abrv" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 27.13 33.91">
                <path d="M17,0H3.39A3.39,3.39,0,0,0,0,3.39L0,30.52a3.38,3.38,0,0,0,3.37,3.39H23.74a3.4,3.4,0,0,0,3.39-3.39V10.17ZM3.39,30.52V3.39H15.26v8.48h8.48V30.52Z"></path>
                <text transform="translate(3 22.41)" style="font-size: 11px;" class="uppercase">{{'CHL'}}</text>
              </svg>
              <svg *ngIf="(formDataStudyCertificate === undefined || formDataStudyCertificate === null) && (urlDataStudyCertificate === null || urlDataStudyCertificate === '')"
                   (click)="openDocumentsPersonalCV('StudyCertificate')"
                   title="EPS" style="fill: red;" class="req-abrv" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 27.13 33.91">
                <path d="M17,0H3.39A3.39,3.39,0,0,0,0,3.39L0,30.52a3.38,3.38,0,0,0,3.37,3.39H23.74a3.4,3.4,0,0,0,3.39-3.39V10.17ZM3.39,30.52V3.39H15.26v8.48h8.48V30.52Z"></path>
                <text transform="translate(3 22.41)" style="font-size: 11px;" class="uppercase">{{'CHL'}}</text>
              </svg>
              <p class="description">{{'Certificado de estudio' || ''}}</p>
              <app-select-search class="select-component-full"
                                 [appearance]="'outline'"
                                 [_dataSource]="educationalLevel" [textInput]="'NIVEL DE ESTUDIOS'" [dataShow]="'Description'" [dataValue]="'Id'" [siteCtrl]="formPersonalCV.get('EducationalLevelId')"
                                 [inputType]="'text'">
              </app-select-search>
            </div>
            <div class="doc-name" *ngIf="exitPermissionCompany('personalespiriencecert.view')">
              <svg *ngIf="(formDataExperienceCertificate !== undefined && formDataExperienceCertificate !== null) || (urlDataExperienceCertificate !== null && urlDataExperienceCertificate !== '')"
                   (click)="openDocumentsPersonalCV('ExperienceCertificate')"
                   title="EPS" style="fill: #4C4C4C" class="req-abrv" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 27.13 33.91">
                <path d="M17,0H3.39A3.39,3.39,0,0,0,0,3.39L0,30.52a3.38,3.38,0,0,0,3.37,3.39H23.74a3.4,3.4,0,0,0,3.39-3.39V10.17ZM3.39,30.52V3.39H15.26v8.48h8.48V30.52Z"></path>
                <text transform="translate(3 22.41)" style="font-size: 11px;" class="uppercase">{{'CHL'}}</text>
              </svg>
              <svg *ngIf="(formDataExperienceCertificate === undefined || formDataExperienceCertificate === null) && (urlDataExperienceCertificate === null || urlDataExperienceCertificate === '')"
                   (click)="openDocumentsPersonalCV('ExperienceCertificate')"
                   title="EPS" style="fill: red;" class="req-abrv" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 27.13 33.91">
                <path d="M17,0H3.39A3.39,3.39,0,0,0,0,3.39L0,30.52a3.38,3.38,0,0,0,3.37,3.39H23.74a3.4,3.4,0,0,0,3.39-3.39V10.17ZM3.39,30.52V3.39H15.26v8.48h8.48V30.52Z"></path>
                <text transform="translate(3 22.41)" style="font-size: 11px;" class="uppercase">{{'CHL'}}</text>
              </svg>
              <p class="description">{{'Certificado de experiencia' || ''}}</p>
              <div class="inputExperient">
                <div class="text-inputExperiendt"><label class="employee-information" style=" font-size: 0.54rem; font-weight: normal !important;">EXPERIENCIA EN EL CARGO</label></div>
                <div class="inputs">
                  <mat-form-field class="input-field-10" appearance="outline">
                    <input matInput type="number" min="0" max="99" step="1" name="num" formControlName="ExperienceYears" style="text-align:right;"
                           onkeypress="return (event.charCode >= 48 && event.charCode <= 57)"
                           onkeyup="if(this.value > 99) this.value = 99"
                    >
                  </mat-form-field>
                  <div class="text-años">Año(s)</div>
                  <mat-form-field class="input-field-10" appearance="outline">
                    <input matInput #ExperienceMonths type="number" [min]="0" [max]="12" formControlName="ExperienceMonths"  style="text-align:right;" onkeypress="return (event.charCode >= 48 && event.charCode <= 57)"
                           onkeyup="if(this.value > 12) this.value = 12">
                  </mat-form-field>
                  <div class="text-años">Meses</div>
                </div>
              </div>
            </div>
            <br>
            <div class="subTitle">Otros Datos</div>
            <div class="fields-group">
              <app-select-search class="input-field-50"
                                 [appearance]="'outline'"
                                 [_dataSource]="maritalStatus" [textInput]="'ESTADO CIVIL'" [dataShow]="'Description'" [dataValue]="'Id'" [siteCtrl]="formPersonalCV.get('MaritalStatusId')"
                                 [inputType]="'text'">
              </app-select-search>
              <mat-form-field class="input-field-50" appearance="outline">
                <label class="employee-information">NUMERO DE HIJOS</label>
                <input matInput type="number" formControlName="NumberOfChilds" [min]="0" [max]="12" onkeypress="return (event.charCode >= 48 && event.charCode <= 57)">
                <mat-error>Requerido</mat-error>
              </mat-form-field>
            </div>
            <div class="fields-group">
              <app-select-search class="input-field-50"
                                 [appearance]="'outline'"
                                 [_dataSource]="socialStratum" [textInput]="'ESTRATO SOCIO ECONOMICO'" [dataShow]="'Description'" [dataValue]="'Id'" [siteCtrl]="formPersonalCV.get('SocialStratumId')"
                                 [inputType]="'text'">
              </app-select-search>
              <mat-form-field class="input-field-50" appearance="outline">
                <label class="employee-information">PERSONAS A CARGO</label>
                <input matInput type="number" formControlName="NumberOfDependants"  [min]="0" [max]="12" onkeypress="return (event.charCode >= 48 && event.charCode <= 57)">
                <mat-error>Requerido</mat-error>
              </mat-form-field>
            </div>
            <div class="subTitle">Salud</div>
            <div class="doc-icon-input">
              <mat-form-field class="select-icon" appearance="outline">
                <label class="employee-information">INDICAR MEDICAMENTOS QUE TOMAS</label>
                <textarea matInput formControlName="Medicines" maxlength="{{100}}"></textarea>
                <mat-error>Requerido</mat-error>
              </mat-form-field>
            </div>
            <form [formGroup]="formVaccine" style="margin-top: 5px;" autocomplete="off">
              <div class="subTitle">Covid19</div>
              <app-select-search class="input-field"
                                 [appearance]="'outline'"
                                 [_dataSource]="vaccinationStatus" [textInput]="'ESTADO'" [dataShow]="'Description'" [dataValue]="'Id'" [siteCtrl]="formVaccine.get('VaccineStatusId')"
                                 [inputType]="'text'">
              </app-select-search>
              <div class="fields-group" *ngIf="getDescriptionStatus(formVaccine.get('VaccineStatusId').value) === 'Vacunado' || getDescriptionStatus(formVaccine.get('VaccineStatusId').value) === 'Parcialmente Vacunado'">
                <app-select-search class="input-field-50"
                                   [appearance]="'outline'"
                                   [_dataSource]="vaccineType" [textInput]="'TIPO DE VACUNA'" [dataShow]="'Description'" [dataValue]="'Id'" [siteCtrl]="formVaccine.get('VaccineTypeId')"
                                   [inputType]="'text'">
                </app-select-search>
                <app-select-search class="input-field-50"
                                   [appearance]="'outline'"
                                   [_dataSource]="arrayDOSIS" [textInput]="'DOSIS APLICADA'" [dataShow]="'name'" [dataValue]="'value'" [siteCtrl]="formVaccine.get('AppliedDose')"
                                   [inputType]="'text'">
                </app-select-search>
              </div>
              <div class="doc-icon-input">
                <mat-form-field class="select-field-full" appearance="outline">
                  <label class="employee-information">OBSERVACIÓN</label>
                  <textarea matInput formControlName="VaccineObservations" maxlength="{{100}}"></textarea>
                  <mat-error>Requerido</mat-error>
                </mat-form-field>
              </div>
            </form>
          </div>
        </form>
      </div>
    </div>

    <!-- ESTA ES EL ADMIN DE CONTRATOS LABORALES -->
    <div class="box" *ngIf="exitPermissionCompany('personalsemployerscontract.view')">
      <div class="header">
        <div class="content" [ngClass]="configCard.color || 'primary'">
          {{ 'CONTRATOS LABORALES' || 'N/A' }}
        </div>
      </div>

      <form [formGroup]="formDatosContrato" autocomplete="off" *ngIf="exitPermissionCompany('personalsemployerscontract.view')">
        <div class="content-card-contracts" *ngIf="exitContractsOffline === true">
          <div class="add-associate-contract-labor">
            <div class="text-add-usuario">
              Crear contrato laboral
            </div>

            <button mat-mini-fab type="button" matTooltipPosition="above" matTooltip="crear"
              [ngClass]="!exitPermissionCompany('personalsemployerscontract.add') || flagListF === true || flagVeto === true ? 'disabledAnalityco': 'blueAnalityco'"
              [disabled]="!exitPermissionCompany('personalsemployerscontract.add') || flagListF === true || flagVeto === true"
              (click)="postIndividualContractLabor()">
              <mat-icon>add</mat-icon>
            </button>
          </div>

          <div class="form-group-list-scroll-states">
            <div *ngIf="!isLoadingLaborContracts && hasAnyContracts && showOnlyActiveLabor && !hasAnyActiveContracts"
              class="clickable-banner" matTooltip="Ver todos (activos e inactivos)" matTooltipPosition="above"
              (click)="onShowAllFromInactiveBannerLabor()">
              <app-title-card-preview
                style="width: 100%; cursor: pointer;"
                [icon]="'help'"
                [text]="'Aqui se visualizan los contratos laborales activos del empleado.'"
                [textTooltip]="'Haz clic para ver también los inactivos.'">
              </app-title-card-preview>
            </div>

            <div class="form-group-list-contracts" *ngFor="let item of visibleLaborContractsSorted; let i = index; trackBy: trackByContractId">
              <form autocomplete="off" style="padding: 7px;"
                (click)="changeSelectedContractLabor(i)">
                <div class="subTitle-contracts">
                  Datos del contrato laboral
                </div>
                <div class="fields-group-contract-labor">
                  <strong style="width: 125px;">
                    CONTRATO No:
                  </strong>

                  <mat-form-field class="input-field-medium" appearance="outline">
                    <input matInput type="text" #inputContractNumber [value]="item.ContractNumber"
                      [disabled]="!exitPermissionCompany('personalsemployerscontract.update') || indexSelectContracLabor !== i || flagListF === true || flagVeto === true"
                      (change)="changeinputContractLaborContractNumber(inputContractNumber.value, i)">
                    <mat-error>Requerido</mat-error>
                  </mat-form-field>

                  <div class="btns-operator">
                    <mat-icon style="margin-left: 10px;"
                      [ngClass]="indexSelectContracLabor === i ? 'activeBtn' : 'inactive'">
                      visibility
                    </mat-icon>

                    <mat-icon style="margin-left: 5px;"
                      [matMenuTriggerFor]="menuPosition"
                      [ngClass]="indexSelectContracLabor === i ? 'activeBtn' : 'inactive'">
                      more_vert
                    </mat-icon>

                    <mat-menu #menuPosition="matMenu">
                      <button mat-menu-item
                        *ngIf="exitPermissionCompany('personalsemployerstermination.start')"
                        (click)="startRetiro(item, i)">
                        Iniciar retiro
                      </button>

                      <button
                        mat-menu-item
                        *ngIf="exitPermissionCompany('personalsemployerscontract.delete')"
                        (click)="deleteContractLabor(item.Id,item.ContractNumber)">
                        Eliminar
                      </button>
                    </mat-menu>
                  </div>
                </div>

                <app-select-search
                  class="select-component-full-employerSelectedContract"
                  [appearance]="'outline'"
                  [_dataSource]="allEmployers"
                  [textInput]="'EMPLEADOR'"
                  [inputType]="'text'"
                  [dataShow]="'Name'"
                  [dataValue]="'Id'"
                  [otherFilter]="'DocumentNumber'"
                  [siteCtrl]="item.ControlEmployerInfoId"
                  [isCard]="true"
                  [_value]="item.EmployerInfoId"
                  [card]="{
                      img: 'Logo',
                      title: 'Name',
                      itemKey: 'DocumentType',
                      itemValue: 'DocumentNumber',
                      finalLeft: 'Rol'
                  }"
                  [disabled]="true"
                  [onErrorUrl]="'employer'"
                  (onSelectionChange)="onSelectedEmployerInfoId($event, i)">
                </app-select-search>

                <app-select-search
                  class="select-component-full-employerSelectedContract"
                  [appearance]="'outline'"
                  [textInput]="'TIPO DE CONTRATO'"
                  [_dataSource]="individualContractsType"
                  [dataShow]="'Description'"
                  [dataValue]="'Id'"
                  [siteCtrl]="item.ControlContractTypeId"
                  [_value]="item.ContractTypeId"
                  [disabled]="!exitPermissionCompany('personalsemployerscontract.update') || indexSelectContracLabor !== i
                              || flagListF === true || flagVeto === true" [inputType]="'text'" (onSelectionChange)="onSelectedContractTypeId($event, i)">
                </app-select-search>

                <div class="fields-group-contract-labor">
                  <mat-form-field class="input-field" appearance="outline">
                    <label class="employee-information">CARGO</label>
                    <input matInput type="text" #inputContractPositionName [value]="item.PositionName" [disabled]="
                          !exitPermissionCompany('personalsemployerscontract.update')
                          || indexSelectContracLabor !== i || flagListF === true || flagVeto === true"
                           (change)="changeinputContractLaborPositionName(inputContractPositionName.value, i)">
                    <mat-error>Requerido</mat-error>
                  </mat-form-field>
                </div>

                <div class="fields-group-contract">
                  <mat-form-field class="input-field-contract" appearance="outline">
                    <label class="employee-information">SALARIO MENSUAL</label>
                    <input matInput #inputContractSalary style="text-align: right;" [value]="item.Salary" [disabled]="
                            !exitPermissionCompany('personalsemployerscontract.update')
                            || indexSelectContracLabor !== i || flagListF === true || flagVeto === true"
                              (change)="changeinputContractLaborSalary(inputContractSalary.value,i)"
                              (keypress)=" changeinputContractLaborSalary(inputContractSalary.value,i)">
                    <mat-error>Requerido</mat-error>
                  </mat-form-field>

                  <div style="margin-left: 5px;">
                    <mat-form-field class="input-field-contract-1" appearance="outline">
                      <label class="employee-information">AUXILIO DE TRANS.</label>
                      <input matInput #inputAuxiliaryTransport style="text-align: right;" [value]="item.TransportationAllowance"
                             [disabled]="indexSelectContracLabor !== i || flagListF === true || flagVeto === true"
                             (change)="changeinputAuxiliaryTransport(inputAuxiliaryTransport.value,i)"
                             (keypress)="changeinputAuxiliaryTransport(inputAuxiliaryTransport.value,i)">
                      <mat-error>Requerido</mat-error>
                    </mat-form-field>
                  </div>

                  <div style="margin-left: 3px;">
                    <mat-form-field class="input-field-contract-2" appearance="none">
                      <label class="employee-information">TOTAL DEVENGADO</label>
                      <input matInput readonly #inputTotalEarnings style="text-align: right;"
                        [value]="formatCurrency(item.TotalEarnings)"
                        [disabled]="indexSelectContracLabor !== i || flagListF === true || flagVeto === true"
                        (change)="changeinputTotalEarnings(inputTotalEarnings.value,i)"
                        (keypress)="changeinputTotalEarnings(inputTotalEarnings.value, i)">
                      <mat-error>Requerido</mat-error>
                    </mat-form-field>
                  </div>
                </div>

                <div class="fields-group-contract-date">
                  <div [ngClass]="getCalculateStateDateMore(item.StartDate, item.Id)">
                    <mat-form-field class="input-field-contract-dates" appearance="outline">
                      <label class="employee-information">FECH.INICIO DE CONTRATO
                        <span *ngIf="getCalculateStateDateMore(item.StartDate,item.Id) === 'DateRed'"
                          [ngClass]="getCalculateStateDateMore(item.StartDate,item.Id) + '-string'">({{
                            getCalculateStateDateMoreLabel(item.StartDate, item.Id) }})
                    </span>
                      </label>

                      <input matInput [matDatepicker]="picker2" #inputDateStartDateContractLabor [value]="item.StartDate"
                        [disabled]="!exitPermissionCompany('personalsemployerscontract.update') || indexSelectContracLabor !== i || flagListF === true || flagVeto === true"
                        (click)="picker2.open()"
                        (dateChange)="changeDateFinishDateContractLabor(inputDateStartDateContractLabor?.value, false, i)">
                      <mat-datepicker #picker2></mat-datepicker>
                      <mat-error>Requerido</mat-error>
                    </mat-form-field>
                  </div>

                  <div>
                    <div [ngClass]="getCalculateStateDateContractEnd(item.EndDate, item.Id)">
                      <mat-form-field class="input-field-mediumdate-contract" appearance="outline">
                        <label class="employee-information">FECH.FIN DE CONTRATO
                          <span *ngIf="item.EndDate && showEndDateBadge(item.EndDate, item.Id)"
                            [ngClass]="getCalculateStateStringContractEnd(item.EndDate,item.Id)">({{
                              getCalculateStateAndHourDescriptionContractEnd(item.EndDate, item.Id) }})
                      </span>
                        </label>

                        <input matInput [matDatepicker]="picker3" #inputDateFinishDateContractLabor [value]="item.EndDate"
                          [disabled]="!exitPermissionCompany('personalsemployerscontract.update') || indexSelectContracLabor !== i || flagListF === true || flagVeto === true"
                          (click)="picker3.open()"
                          (dateChange)="changeDateFinishDateContractLabor(inputDateFinishDateContractLabor?.value, true,i)">
                        <mat-datepicker #picker3></mat-datepicker>
                        <mat-error>Requerido</mat-error>
                      </mat-form-field>
                    </div>
                  </div>
                </div>

                <div class="subTitle-contracts">Cuenta bancaria</div>
                <br>
                <div>
                  <app-select-search
                    class="input-field"
                    [appearance]="'outline'"
                    [_dataSource]="bancks"
                    [textInput]="'Banco'"
                    [dataShow]="'Name'"
                    [dataValue]="'Id'"
                    [siteCtrl]="item.ControlBankId"
                    [_value]="item.BankId"
                    [disabled]="!exitPermissionCompany('personalsemployerscontract.update') || indexSelectContracLabor !== i || flagListF === true || flagVeto === true"
                    [inputType]="'text'"
                    (onSelectionChange)="onSelectedBankId($event, i)">
                  </app-select-search>

                  <div class="fields-group-contract-labor">
                    <div class="fields-group-contract-labor">
                      <mat-form-field class="input-field" appearance="outline">
                        <label class="employee-information">NO CUENTA BANCARIA</label>
                        <input matInput type="text" #inputContractBankAccount [value]="item.BankAccount"
                          [disabled]="!exitPermissionCompany(
                          'personalsemployerscontract.update') || indexSelectContracLabor !== i || flagListF === true || flagVeto === true"
                          (change)="changeinputContractLaborBankAccount(inputContractBankAccount.value, i)">
                        <mat-error>Requerido</mat-error>
                      </mat-form-field>
                    </div>

                    <app-select-search
                      class="select-field-medium-short-contract-labor"
                      [appearance]="'outline'"
                      [_dataSource]="bankAccountType"
                      [textInput]="'Tipo'"
                      [dataShow]="'Description'"
                      [dataValue]="'Id'"
                      [siteCtrl]="item.ControlBankAccountTypeId"
                      [_value]="item.BankAccountTypeId"
                      [disabled]="!exitPermissionCompany('personalsemployerscontract.update') || indexSelectContracLabor !== i || flagListF === true || flagVeto === true"
                      [inputType]="'text'"
                      (onSelectionChange)="onSelectedBankAccountTypeId($event, i)">
                    </app-select-search>
                  </div>
                </div>

                <!-- LUGAR Y TURNO DE TRABAJO -->
                <div class="subTitle-contracts">Lugar y turno de trabajo (Pre-nomina)</div>
                <br>
                <!-- LUGAR DE TRABAJO -->
                <div class="timeExtras workplace-row">
                    <div class="workplace-stack">
                      <span class="workplace-label">Lugar de trabajo</span>
                      <span class="workplace-value-text">{{ getWorkplaceName(item) }}</span>
                    </div>
                    <mat-icon class="workplace-edit-icon" [ngClass]="{'workplace-edit-icon--disabled': !canEditWorkplace(i)}"
                      matTooltip="Editar lugar de trabajo"
                      matTooltipPosition="above"
                      (click)="openChangeWorkplaceDialog(item, i)">
                      edit
                    </mat-icon>
                </div>

                <!-- PROGRAMACIÓN DE TURNOS -->
                <div class="timeExtras config-action-workshift">
                    <div class="timeExtrasText">Programación de turnos</div>
                    <span class="work-schedule-tooltip" matTooltipPosition="above"
                          [matTooltip]="canOpenWorkScheduleCalendar(i)? 'Programación de turnos': 'No cuentas con permiso para ver la programación de turnos'">
                          <button mat-icon-button type="button" class="work-schedule-button" aria-label="Abrir programación de turnos"
                            [disabled]="!canOpenWorkScheduleCalendar(i)"
                            (click)="$event.stopPropagation();
                              openWorkScheduleCalendarDialog(item, i)">
                            <mat-icon>settings</mat-icon>
                          </button>
                    </span>
                </div>

                <!-- CALCULAR HORAS EXTRAS -->
                <div class="timeExtras">
                  <div class="timeExtrasText">Calcular horas extras</div>
                  <app-select-search
                    class="input-field"
                    style="width: 80px;"
                    [appearance]="'outline'"
                    [_dataSource]="HasExtraTimeList"
                    [textInput]="''"
                    [dataShow]="'name'"
                    [dataValue]="'value'"
                    [siteCtrl]="item.ControlHasExtraTime"
                    [_value]="item.HasExtraTime"
                    [disabled]="!exitPermissionCompany('personalsemployerscontract.update') || indexSelectContracLabor !== i || flagListF === true || flagVeto === true"
                    [inputType]="'text'"
                    (onSelectionChange)="onSelectedHasExtraTime($event, i)">
                  </app-select-search>
                </div>
              </form>
            </div>
          </div>

          <app-title-card-preview
            *ngIf="!isLoadingLaborContracts && !hasAnyContracts"
            style="width: 100%;"
            [icon]="'help'"
            [text]="'Aqui se visualizan los contratos laborales'"
            [textTooltip]="'Aqui se visualizan los contratos laborales'">
          </app-title-card-preview>

          <div class="expansion-action" matTooltipPosition="above"
            [matTooltip]="showOnlyActiveLabor ? 'Ver todos (activos e inactivos)' : 'Ver solo activos'"
            (click)="toggleShowOnlyActiveLabor()">
        <span class="toggle-text">
          {{showOnlyActiveLabor ? 'Ver inactivos' : 'Ver solo activos' }}
        </span>
            <mat-icon>
              {{showOnlyActiveLabor ? 'expand_more' : 'expand_less' }}
            </mat-icon>
          </div>
        </div>
      </form>

      <!-- PRE-LOADING -->
      <div class="content-card list-card pre-content" *ngIf="exitContractsOffline === false">
        <div class="form-group-list" *ngFor="let item of production.pre_loading">
          <div class="card">
            <div class="relational-info">
              <div class="desc flex" style="width: 18px;">
                <div class="icon-pre pre-loading"></div>
                <div class="title-pre pre-loading"></div>
              </div>

              <div class="icon-pre pre-loading"></div>
            </div>

            <div class="card-content">
              <div class="pre-img pre-loading"></div>
              <div class="content-information">
                <div class="text-pre pre-loading"></div>
                <div class="text-pre pre-loading"></div>
                <div class="text-pre pre-loading"></div>
              </div>
            </div>
          </div>
          <hr>
        </div>
      </div>
    </div>
  </div>

  <!-- ESTA ES EL ADMIN DE CONTRATOS Y PROYECTOS VINCULADOS -->
  <div>
    <div class="box" *ngIf="exitPermissionCompany('personalscontracts.view')">
      <div class="header">
        <div class="content" [ngClass]="configCard.color || 'primary'">{{'VINCULADOS A LOS CONTRATOS Y PROYECTOS' || 'N/A'}}</div>
      </div>
      <ng-container *ngIf="getExpansionConfigValue('vincProjecContrac')">
      <div class="content-card-contracts" *ngIf="exitContractsOffline === true">
        <div class="add-associate-contract">
          <div class="item-group">
            <div class="text-add-usuario">Activar</div>
            <span
              [matTooltip]="activarTooltip()"
              matTooltipPosition="above"
              style="display:inline-block">
              <button
                mat-mini-fab
                [ngClass]="activarBtnClass()"
                type="button"
                matTooltip="Vincular a otros contratos"
                matTooltipPosition="below"
                (click)="associateContrac()"
                [disabled]="isActivarDisabled()">
                <mat-icon>add</mat-icon>
              </button>
            </span>
          </div>
          <div class="item-group">
            <div class="text-add-usuario">Inactivar</div>
            <button mat-mini-fab [ngClass]="!exitPermissionCompany('firepersonal.update') || (flagListF === true || flagVeto === true)? 'disabledAnalityco': 'redInactivar'" type="button" matTooltipPosition="above" matTooltip="inactivar"
                    (click)="inactiveContrac()" [disabled]="!exitPermissionCompany('firepersonal.update') || (flagListF === true || flagVeto === true)">
              <mat-icon>remove</mat-icon>
            </button>
          </div>
          <div class="item-group">
            <div class="text-add-usuario" *ngIf="exitPermissionCompany('contractspersonals.update')" style="margin-left: 10px;">Modificar<br>requisitos</div>
            <button mat-mini-fab style="background-color: #6aca25; color: white; margin-left: 5px;" *ngIf="exitPermissionCompany('contractspersonals.update')" type="button" matTooltipPosition="above" matTooltip="Modificar requisitos"
                    (click)="openMassiveArlDialog()" [disabled]="(flagListF === true || flagVeto === true)">
              <mat-icon>edit</mat-icon>
            </button>
          </div>
        </div>
        <div  *ngIf="showOnlyActive && getVisibleContracts().length === 0" (click)="onShowAllFromInactiveBanner()">
          <app-title-card-preview
            style="width: 100%;"
            [icon]="'help'"
            [text]="'Aqui se visualizan los contratos donde la persona esta activa'"
            [textTooltip]="'Aqui se visualizan los contratos donde la persona esta activa'">
          </app-title-card-preview>
        </div>

        <div class="form-group-list-scroll-states" *ngIf="!showOnlyActive || getVisibleContracts().length > 0">
          <div class="form-group-list-contracts" *ngFor="let item of getVisibleContracts(); let i = index">
            <div class="card">
              <div class="relational-info" (click)="selectContract(i)">
                <div class="desc">
                  <mat-icon>location_city</mat-icon>
                  <div class="proj">
                    <h3 *ngFor="let proj of getNamesProyect(item.ProjectContracts) || [];">
                      <div [ngClass]="getCalculateStateDateString(proj.FinishDate)" style="padding-left: 2px; margin-top: -12px;" >{{proj.Name+','}}</div>
                    </h3>
                  </div>
                </div>
                <mat-icon style="margin-right: 12px;" [ngClass]="indexSelect === i ? 'activeBtn':'inactive'" (click)="selectContract(i)">visibility</mat-icon>
              </div>
              <div class="card-content" (click)="goContract(item?.Id)" style="cursor: pointer;">
                <img src="{{s3Bucket+item.FormImageLogo}}" alt="">
                <div class="content-information">
                  <div class="ellipsis">{{item.ContractReview || ''}}</div>
                  <div class="ellipsis" matTooltip="{{item.EmployerName}}">{{item.EmployerName || ''}}</div>
                  <div class="ellipsis baseline" [ngClass]="getCalculateStateDateString(item.FinishDateContract, item.Id)">
                    <mat-icon>today</mat-icon>&nbsp;&nbsp;&nbsp;&nbsp;
                    <div>{{fechasService.getDateFormatR(item.FinishDateContract) || ''}}&nbsp;&nbsp;{{item.ContractNumber || ''}}</div>
                  </div>
                </div>
              </div>
            </div>
            <div class="fields-group" (click)="selectContract(i)" >
              <div class="fields-group" (click)="selectContract(i)" [ngClass]="getCalculateStateDateMore(item.StartDate, item.Id)">
                <div class="labeTimePiecker" style="display: flex; flex-direction: column; align-items: flex-start; margin-right: 20px; margin-left: 10px;">
                  <mat-label class="classLabel">INICIO DEL ACCESO <mat-label *ngIf="getCalculateStateDateMore(item.StartDate, item.Id) ? 'DateRed':''" [ngClass]="getCalculateStateDateMore(item.StartDate, item.Id)+'-string'">({{getCalculateStateDateMoreLabel(item.StartDate, item.Id) }})</mat-label></mat-label>
                  <div class="input-field-medium-date-datetime">
                    <mat-form-field appearance="outline">
                      <input matInput type="datetime-local"
                             style="max-width: 140px !important; height: 20px !important; display: flex; flex-direction: column;"
                             #inputDateStartDateContracttime
                             [value]="this.fechasService.getDateHours(item?.StartDate)"
                             [min]="minDateVigenciaContract"
                             (change)="changeDateFinishDateContractTime(inputDateStartDateContracttime?.value, false)"
                             (paste)="$event.preventDefault()"
                             [disabled]="!exitPermissionCompany('personalscontractsvalidity.config') || indexSelect !== i || getCalculateStateDate(item.FinishDateContract, item.Id) === 'DateRed' || (flagListF === true || flagVeto === true)"
                      >
                    </mat-form-field>
                  </div>
                </div>
              </div>
              <div class="fields-group" (click)="selectContract(i)" [ngClass]="getCalculateStateDateWithHORA(item.FinishDate, item.Id)">
                <div class="fields-group" style="margin-left: 1px;" (click)="selectContract(i)" [ngClass]="getCalculateStateDateWithHORA(item.FinishDate, item.Id)">
                  <div class="labeTimePiecker" style="display: flex; flex-direction: column;">
                    <mat-label class="classLabel">FIN DEL ACCESO <mat-label *ngIf="getIsOutDate(item.FinishDate, item.Id)" [ngClass]="getCalculateStateDateString(item.FinishDate, item.Id)">({{getCalculateStateDateAndHourDescription(item.FinishDate, item.Id)}})</mat-label></mat-label>
                    <div class="input-field-medium-date-datetime">
                      <mat-form-field appearance="outline">
                        <input matInput type="datetime-local"
                               style="max-width: 140px !important; height: 20px !important; display: flex; flex-direction: column;"
                               #inputDateFinishDateContracttime
                               [value]="this.fechasService.getDateHours(item?.FinishDate)"
                               (change)="changeDateFinishDateContractTime(inputDateFinishDateContracttime?.value, true)"
                               [min]="minDateVigenciaContract"
                               [max]="maxDate"
                               (paste)="$event.preventDefault()"
                               [disabled]="!exitPermissionCompany('personalscontractsvalidity.config') || indexSelect !== i || getCalculateStateDateWithHORA(item.FinishDateContract, item.Id) === 'DateRed' || (flagListF === true || flagVeto === true)"
                        >
                      </mat-form-field>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <br *ngIf="!exitPermissionCompany('personalscontractsposition.configposition')">
            <div class="fields-group" (click)="selectContract(i)">
              <div class="labeTimePiecker" style="display: flex; flex-direction: column; align-items: flex-start; margin-left: 10px;">
                <mat-label class="classLabel">FUNCION</mat-label>
                <div class="input-field-medium-date-funcion" matTooltip="FUNCION">
                  <mat-form-field *ngIf="exitPermissionCompany('personalscontractsposition.configposition')" appearance="outline" style="width: 87%;">
                    <input matInput
                           type="text"
                           #inputPosition
                           [value]="item.Position"
                           (change)="changeinputPositionContract(inputPosition.value)"
                           [disabled]="indexSelect !== i || (flagListF === true || flagVeto === true)"
                           [matAutocomplete]="auto" maxlength="40">
                    <mat-autocomplete autoActiveFirstOptionItem #auto="matAutocomplete">
                      <mat-option *ngFor="let option of positionSujester" [value]="option" (click)="changeinputPositionContract(option)">
                        {{option || ''}}
                      </mat-option>
                    </mat-autocomplete>
                    <mat-error>Requerido</mat-error>
                  </mat-form-field>
                  <div *ngIf="!exitPermissionCompany('personalscontractsposition.configposition')">{{item.Position}}</div>
                </div>
              </div>
            </div>

            <div class="fields-group" (click)="selectContract(i)">
              <div class="labeTimePiecker" style="display: flex; flex-direction: column; align-items: flex-start;  margin-left: 8px;">
                <div class="empleadorContratista" style="margin-bottom: 2px;">
                  <mat-label class="classLabel">EMPLEADOR ({{validateIfEmployerContratista(item.EmployerId, item.EmployerName) || ''}})</mat-label>
                </div>
                <div class="input-field-medium-date-funcion" matTooltip="EMPLEADOR" style="margin-top: -8px; margin-bottom:12px; ">
                  <app-select-search class="select-component-full-employerSelected"
                                     [style]="'width: 87%'"
                                     [appearance]="'outline'"
                                     [_dataSource]="allEmployers" [textInput]="''" [inputType]="'text'"
                                     [dataShow]="'Name'" [dataValue]="'Id'" [otherFilter]="'DocumentNumber'" [siteCtrl]="item.Control"
                                     [isCard]="true" [_value]="item.EmployerId"
                                     [card]="{img: 'Logo', title: 'Name', itemKey: 'DocumentType', itemValue:'DocumentNumber', finalLeft: 'Rol'}"
                                     (onSelectionChange)="onSelectedAllEmployer($event)"
                                     [disabled]="indexSelect !== i || (flagListF === true || flagVeto === true)? true: false || disabledByPermissionUpdate"
                                     [onErrorUrl]="'employer'"
                  >
                  </app-select-search>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- pre-loading -->
      <div class="content-card list-card pre-content" *ngIf="exitContractsOffline === false">
        <div class="form-group-list" *ngFor="let item of production.pre_loading">
          <div class="card">
            <div class="relational-info">
              <div class="desc flex" style="width: 18px;">
                <div class="icon-pre pre-loading"></div>
                <div class="title-pre pre-loading"></div>
              </div>
              <div class="icon-pre pre-loading"></div>
            </div>
            <div class="card-content">
              <div class="pre-img pre-loading"></div>
              <div class="content-information">
                <div class="text-pre pre-loading"></div>
                <div class="text-pre pre-loading"></div>
                <div class="text-pre pre-loading"></div>
              </div>
            </div>
          </div>
          <hr>
        </div>
      </div>
      <app-card-information *ngIf="!exitPermissionCompany('personalscontracts.view')"
                            [configCard]="{typeCard: 'default', title:'VINCULADOS A LOS CONTRATOS Y PROYECTOS'}"
                            [notListDescription]="'Aquí se visualizaran contratos y proyectos  vinculados'"
      >
      </app-card-information>
    </ng-container>
      <div class="expansion-action"
           [matTooltip]="showOnlyActive ? 'Ver todos (activos e inactivos)' : 'Ver solo activos'"
           matTooltipPosition="above"
           (click)="onToggleClick()">
          <span style="font-weight: 500; font-size: 13px; color: #555;">
          {{ showOnlyActive ? 'Ver inactivos' : 'Ver solo activos' }}</span>
        <mat-icon>{{ showOnlyActive ? 'expand_more' : 'expand_less' }}</mat-icon>
      </div>
    </div>

    <!-- CAPACITACIONES CON EXAMEN -->
    <div class="box" *ngIf="exitPermissionCompany('trainingpersonal.view')">
      <div class="header">
        <div class="content" [ngClass]="configCard.color || 'primary'">{{'CAPACITACIONES CON EXAMEN' || 'N/A'}}</div>
      </div>
      <div class="content-card list-card-personal">
        <div class="form-group-personal">
          <div class="card-user-viculado" [ngClass]="{'no-scroll': trainings.length <= 5}">
                <div class="card-wrapper" *ngFor="let training of sortedTrainings">
                  <app-card
                    [cardInformation]="true"
                    [title]="training.item.Training.Name"
                    [photo]="training.item.Training.ImagePath"
                    [onErrorUrl]="'noImage'"
                    [item1]="'Elaborado: ' + (training.item.DateTaken | date:'dd/MM/yyyy')"
                    [itemF1]="training.item.Passed && training.item.ExpirationDate? ('Vence: ' + (training.item.ExpirationDate | date:'dd MMM yyyy')): ''"
                    [ngClass]="{'vence-rojo': training.venceColor === 'red','vence-naranja': training.venceColor === 'orange',
                                'vence-gris': training.venceColor === 'grey'}"
                    (click)="historyTraining(training.item.Id, getEmployerName(training?.item), training.item.ApprovalPercentage)">
                  </app-card>
                  <div class="status-icon"
                       [ngClass]="{ 'passed': training.item.Passed, 'failed': !training.item.Passed }"
                       *ngIf="training.item.Passed !== null">{{ training.item.Passed ? '✔' : '✘' }}</div>
                </div>
          </div>
          <app-title-card-preview
                *ngIf="trainings.length === 0"
                style="width: 100%;"
                [icon]="'help'"
                [text]="'Aqui se visualizan las capacitaciones con examen'"
                [textTooltip]="'Aqui se visualizan las capacitaciones con examen'"
          ></app-title-card-preview>
        </div>
      </div>
    </div>
</div>

<!-- DOCUMENTOS Y REQUISITOS DE ACCESO -->
  <div oncopy='return false' oncut='return false'>
    <div class="box" *ngIf="exitPermissionCompany('personalsrequirements.view')">
      <div class="header">
        <div class="content" [ngClass]="'greendAnalityco2'">{{'DOCUMENTOS Y REQUISITOS DE ACCESO' || 'N/A'}}</div>
      </div>
      <div>
        <!-- pre-loading -->
        <div class="content-Document">
          <div class="content-card list-card pre-content" *ngIf="exitContractsOffline === false">
            <div class="form-group-list" *ngFor="let item of production.pre_loading">
              <div class="card">
                <div class="relational-info">
                  <div class="desc flex" style="width: 18px;">
                    <div class="icon-pre pre-loading"></div>
                    <div class="title-pre pre-loading"></div>
                  </div>
                  <div class="icon-pre pre-loading"></div>
                </div>
                <div class="card-content">
                  <div class="pre-img pre-loading"></div>
                  <div class="content-information">
                    <div class="text-pre pre-loading"></div>
                    <div class="text-pre pre-loading"></div>
                    <div class="text-pre pre-loading"></div>
                  </div>
                </div>
              </div>
              <hr>
            </div>
          </div>
          <div class="card-description" *ngIf="exitContractsOffline === true">
            <div class="form-group-list" *ngIf="contracts.length > 0">
              <div class="description-title">
                <div class="desc flex" style="width: 100%;">
                  <h3>{{'Requisitos de acceso por cargo '}}</h3>
                </div>
                <mat-icon *ngIf="(flagListF === false && flagVeto === false) && exitPermissionCompany('personalsrequirements.update')" class="icon-setting" (click)="openAcceso()" style="cursor: pointer;"
                >settings</mat-icon>
                <mat-icon *ngIf="(flagListF === true || flagVeto === true) || !exitPermissionCompany('personalsrequirements.update')" class="icon-setting-not" style="cursor: pointer;"
                >settings</mat-icon>
              </div>
            </div>
            <div class="form-group-list" *ngIf="contracts.length > 0">
              <form [formGroup]="formVigenciaArlExigida">
                <div class="description-title-req" style="max-width: 260px !important; margin-top: 10px;">
                  <div class="desc flex" style="width: 80%;">
                    <h3>{{'Tipo de riesgo exigido de ARL '}}</h3>
                  </div>
                  <app-select-search class="select-component-mini"
                                     [appearance]="'outline'"
                                     [_dataSource]="occupationalRisk" [textInput]="''" [dataShow]="'Description'" [dataValue]="'Description'" [siteCtrl]="formVigenciaArlExigida.get('TypeARL')"
                                     [inputType]="'text'" (onSelectionChange)="changeTypeRiesgo($event)" [disabled]="flagListF || flagVeto || disabledByPermissionUpdate">
                  </app-select-search>
                </div>
              </form>
            </div>
            <div class="not-Information-Select" *ngIf="contracts.length === 0">No hay información</div>
          </div>

          <app-title-card-preview
            style="width: 100%;"
            [icon]="'error'"
            [text]="validatePersonalAlert() ? 'ACCESO AUTORIZADO' : 'ACCESO NO AUTORIZADO'"
            [textTooltip]="validatePersonalAlert() ? 'ACCESO AUTORIZADO' : 'ACCESO NO AUTORIZADO'"
            [subText]="subTitlePersonalAlert()"
            [isInfo]="false"
            [isAuthorized]="validatePersonalAlert()"
          ></app-title-card-preview>
        </div>

        <div class="content-card">
          <div class="sub-header"  *ngIf="contractsOffline.length > 0 && exitContractsOffline === true && contracts.length !== 0" >
            <div class="sub-content" style="background: #53DF79 !important;">{{'EXIGIDOS' || 'N/A'}}</div>
          </div>
          <div class="content-card-documentos list-card" *ngIf="contractsOffline.length > 0 && exitContractsOffline === true && contracts.length !== 0">
            <div class="form-group-list">
              <form>
                <div class="item-list-docs">
                  <h2 style="font-weight: 500; color: black; margin: 0px !important;" class="edadRange">
                    <svg *ngIf="edadRange === true" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" viewBox="0 0 26 26" enable-background="new 0 0 26 26" width="100%" height="100%" fit="" preserveAspectRatio="xMidYMid meet" focusable="false">
                      <path d="m.3,14c-0.2-0.2-0.3-0.5-0.3-0.7s0.1-0.5 0.3-0.7l1.4-1.4c0.4-0.4 1-0.4 1.4,0l.1,.1 5.5,5.9c0.2,0.2 0.5,0.2 0.7,0l13.4-13.9h0.1v-8.88178e-16c0.4-0.4 1-0.4 1.4,0l1.4,1.4c0.4,0.4 0.4,1 0,1.4l0,0-16,16.6c-0.2,0.2-0.4,0.3-0.7,0.3-0.3,0-0.5-0.1-0.7-0.3l-7.8-8.4-.2-.3z" fill="#03a9f4"></path>
                    </svg>
                    <svg *ngIf="edadRange === false" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Capa_1_cache3" x="0px" y="0px" viewBox="0 0 174.239 174.239" style="enable-background:new 0 0 174.239 174.239;" xml:space="preserve" width="100%" height="100%" fit="" preserveAspectRatio="xMidYMid meet" focusable="false">
                                        <path style="width: 40px; height: 40px;" d="M146.537,1.047c-1.396-1.396-3.681-1.396-5.077,0L89.658,52.849c-1.396,1.396-3.681,1.396-5.077,0L32.78,1.047  c-1.396-1.396-3.681-1.396-5.077,0L1.047,27.702c-1.396,1.396-1.396,3.681,0,5.077l51.802,51.802c1.396,1.396,1.396,3.681,0,5.077  L1.047,141.46c-1.396,1.396-1.396,3.681,0,5.077l26.655,26.655c1.396,1.396,3.681,1.396,5.077,0l51.802-51.802  c1.396-1.396,3.681-1.396,5.077,0l51.801,51.801c1.396,1.396,3.681,1.396,5.077,0l26.655-26.655c1.396-1.396,1.396-3.681,0-5.077  l-51.801-51.801c-1.396-1.396-1.396-3.681,0-5.077l51.801-51.801c1.396-1.396,1.396-3.681,0-5.077L146.537,1.047z" fill="#D80027"></path>
                      <g>
                                        </g>
                      <g>
                                        </g>
                      <g>
                                        </g>
                      <g>
                                        </g>
                      <g>
                                        </g>
                      <g>
                                        </g>
                      <g>
                                        </g>
                      <g>
                                        </g>
                      <g>
                                        </g>
                      <g>
                                        </g>
                      <g>
                                        </g>
                      <g>
                                        </g>
                      <g>
                                        </g>
                      <g>
                                        </g>
                      <g>
                                        </g>
                                    </svg>
                    {{biometricMaxMin}}
                  </h2>
                </div>
                <div class="item-list-docs">
                  <mat-icon style="font-size: 26px !important;">today</mat-icon>&nbsp;&nbsp;&nbsp;&nbsp;<div>{{'Calendario: ' +'Dom,Lun,Mar,Mie,Jue,Vie,Sab'}}</div>
                </div>
                <div class="item-list-docs">
                  <mat-icon style="font-size: 26px !important;">schedule</mat-icon>&nbsp;&nbsp;&nbsp;&nbsp;<div>{{getScheduleText()}}</div>
                </div>
                <div class="item-list-docs" *ngFor="let socialSecur of socialSecurity || []" [ngSwitch]="socialSecur.Type">
                  <div class="doc-name">
                    <div class="text" *ngSwitchCase = "'EPS'">
                      <app-img
                        [type]="getshowDocumentos(socialSecur ,socialSecur.DocsJSON !== '{}' && socialSecur.DocsJSON !== '' && socialSecur.DocsJSON !== null ? 'negro': 'rojo')"
                        [text]="socialSecur.Type"
                        [color]="socialSecur.DocsJSON !== '{}' && socialSecur.DocsJSON !== '' && socialSecur.DocsJSON !== null ? 'negro': 'rojo'"
                        [width]="50"
                        [height]="50"
                        (click)="showDocumentos(socialSecur, 'SocialSecurity')"
                        matTooltipPosition="above"
                        [matTooltip]="socialSecur.Desc"
                      ></app-img>
                      <div class="select-component-medium" *ngIf="socialSecur.Model !== undefined && (flagListF !== true && flagVeto !== true)">
                        <app-select-search class="select-component-medium"
                                           *ngSwitchCase = "'EPS'"
                                           [appearance]="'outline'"
                                           [disabled]="!this.exitPermissionCompany('personalsrequirements.updatebyposition')"
                                           [_dataSource]="eps" [textInput]="'EPS'" [dataShow]="'Name'" [dataValue]="'Id'" [siteCtrl]="controEps"
                                           [inputType]="'text'" (onSelectionChange)="replaceEPSorAFP({path: '/EpsId', value:$event})" >
                        </app-select-search>
                      </div>
                      <p class="description"  style="margin:0; pointer-events:none;"
                         *ngIf="socialSecur.Model === undefined || (flagListF === true|| flagVeto === true)">{{socialSecur.EPSName || ''}}
                      </p>
                      <div class="datepikerInput" [ngClass]="getCalculateStateDate(getDateDocsUploadIniadoSocialSecurity(socialSecur.Id))"
                           *ngIf="((socialSecur.Model === undefined && getCalculateStateDate(getDateDocsUploadIniadoSocialSecurity(socialSecur.Id)) === 'DateRed')
                                  && (flagListF !== true && flagVeto !== true)) || ((socialSecur.Model !== undefined) && (flagListF !== true && flagVeto !== true))">
                        <mat-form-field class="input-field-medium" appearance="outline">
                          <label><strong>{{socialSecur!.DateLabel || ''}}</strong></label>
                          <input matInput [matDatepicker]="pickerSocialEPS" #inputDateSocialEPS (click)="pickerSocialEPS.open()"
                                 (dateChange)="changeDateRequirement(socialSecur.Model, socialSecur.Id, inputDateSocialEPS.value)"
                                 [value]="getDateRequirement(socialSecur.Id)"
                                 [disabled]="!this.exitPermissionCompany('personalsrequirements.updatebyposition')"
                                 [min]="minDateSocialSecurity" [max]="maxDateSocialSecurity" readonly
                          >
                          <mat-datepicker #pickerSocialEPS></mat-datepicker>
                          <mat-error>Requerido</mat-error>
                        </mat-form-field>
                      </div>
                      <p class="description"
                         *ngIf="(socialSecur.Model === undefined && getCalculateStateDate(getDateDocsUploadIniadoSocialSecurity(socialSecur.Id)) !== 'DateRed')
                                || (flagListF === true || flagVeto === true)">{{getDateRequirement(socialSecur.Id) | date:'dd/MM/yyyy' || ''}}
                      </p>
                    </div>
                    <div class="text" *ngSwitchCase = "'ARL'">
                      <app-img
                        [type]="getshowDocumentos(socialSecur ,socialSecur.DocsJSON !== '{}' && socialSecur.DocsJSON !== '' && socialSecur.DocsJSON !== null ? 'negro': 'rojo')"
                        [text]="socialSecur.Type"
                        [color]="socialSecur.DocsJSON !== '{}' && socialSecur.DocsJSON !== '' && socialSecur.DocsJSON !== null ? 'negro': 'rojo'"
                        [width]="50"
                        [height]="50"
                        (click)="showDocumentos(socialSecur, 'SocialSecurity')"
                        matTooltipPosition="above"
                        [matTooltip]="socialSecur.Desc"
                      ></app-img>
                      <p class="description">{{personalInfo?.NameARL || ''}}</p>
                      <div class="datepikerInput" [ngClass]="getCalculateStateDate(getDateDocsUploadIniadoSocialSecurity(socialSecur.Id))"
                           *ngIf=" ((socialSecur.Model === undefined && getCalculateStateDate(getDateDocsUploadIniadoSocialSecurity(socialSecur.Id)) === 'DateRed')
                            && (flagListF !== true && flagVeto !== true)) || ((socialSecur.Model !== undefined) && (flagListF !== true && flagVeto !== true))">
                        <mat-form-field class="input-field-medium" appearance="outline">
                          <label><strong>{{socialSecur!.DateLabel || ''}}</strong></label>
                          <input matInput [matDatepicker]="pickerSocialARL" #inputDateSocialARL (click)="pickerSocialARL.open()"
                                 (dateChange)="changeDateRequirement(socialSecur.Model, socialSecur.Id, inputDateSocialARL.value)"
                                 [value]="getDateRequirement(socialSecur.Id)"
                                 [disabled]="!this.exitPermissionCompany('personalsrequirements.updatebyposition')"
                                 [min]="minDateSocialSecurity" [max]="maxDateSocialSecurity" readonly
                          >
                          <mat-datepicker #pickerSocialARL></mat-datepicker>
                          <mat-error>Requerido</mat-error>
                        </mat-form-field>
                      </div>
                      <p class="description"
                         *ngIf="(socialSecur.Model === undefined && getCalculateStateDate(getDateDocsUploadIniadoSocialSecurity(socialSecur.Id)) !== 'DateRed')
                                            || (flagListF === true || flagVeto === true)"
                      >{{getDateRequirement(socialSecur.Id) | date:'dd/MM/yyyy' || ''}}
                      </p>
                    </div>
                    <div class="text" *ngSwitchCase = "'AFP'">
                      <app-img
                        [type]="getshowDocumentos(socialSecur ,socialSecur.DocsJSON !== '{}' && socialSecur.DocsJSON !== '' && socialSecur.DocsJSON !== null ? 'negro': 'rojo')"
                        [text]="socialSecur.Type"
                        [color]="socialSecur.DocsJSON !== '{}' && socialSecur.DocsJSON !== '' && socialSecur.DocsJSON !== null ? 'negro': 'rojo'"
                        [width]="50"
                        [height]="50"
                        (click)="showDocumentos(socialSecur, 'SocialSecurity')"
                        matTooltipPosition="above"
                        [matTooltip]="socialSecur.Desc"
                      ></app-img>

                      <div class="select-component-medium" *ngIf="socialSecur.Model !== undefined && (flagListF !== true && flagVeto !== true)">
                        <app-select-search class="select-component-medium" *ngSwitchCase = "'AFP'"
                                           [appearance]="'outline'"
                                           [_dataSource]="afp" [textInput]="'AFP'" [dataShow]="'Name'" [dataValue]="'Id'" [siteCtrl]="controAfp"
                                           [inputType]="'text'" (onSelectionChange)="replaceEPSorAFP({path: '/AfpId', value:$event})" >
                        </app-select-search>
                      </div>
                      <p class="description"
                         *ngIf="socialSecur.Model === undefined
                                            || (flagListF === true || flagVeto === true)"
                      >{{socialSecur.AFPName || ''}}
                      </p>
                      <div class="datepikerInput" [ngClass]="getCalculateStateDate(getDateDocsUploadIniadoSocialSecurity(socialSecur.Id))"
                           *ngIf=" ((socialSecur.Model === undefined && getCalculateStateDate(getDateDocsUploadIniadoSocialSecurity(socialSecur.Id)) === 'DateRed')
                            && (flagListF !== true && flagVeto !== true)) || ((socialSecur.Model !== undefined) && (flagListF !== true && flagVeto !== true))">
                        <mat-form-field class="input-field-medium" appearance="outline">
                          <label><strong>{{socialSecur!.DateLabel || ''}}</strong></label>
                          <input matInput [matDatepicker]="pickerSocialAFP" #inputDateSocialAFP (click)="pickerSocialAFP.open()"
                                 (dateChange)="changeDateRequirement(socialSecur.Model, socialSecur.Id, inputDateSocialAFP.value)"
                                 [value]="getDateRequirement(socialSecur.Id)"
                                 [disabled]="!this.exitPermissionCompany('personalsrequirements.updatebyposition')"
                                 [min]="minDateSocialSecurity" [max]="maxDateSocialSecurity"
                                 oncopy="return false" readonly
                          >

                          <mat-datepicker #pickerSocialAFP></mat-datepicker>
                          <mat-error>Requerido</mat-error>
                        </mat-form-field>
                      </div>
                      <p class="description"
                         *ngIf="(socialSecur.Model === undefined && getCalculateStateDate(getDateDocsUploadIniadoSocialSecurity(socialSecur.Id)) !== 'DateRed')
                                            || (flagListF === true || flagVeto === true)"
                      >{{getDateRequirement(socialSecur.Id) | date:'dd/MM/yyyy' || ''}}
                      </p>
                    </div>
                  </div>

                  <div class="TypeARLisValided" *ngSwitchCase = "'ARL'">
                    <svg *ngIf="IsValidedARL === true" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" viewBox="0 0 26 26" enable-background="new 0 0 26 26" width="100%" height="100%" fit="" preserveAspectRatio="xMidYMid meet" focusable="false">
                      <path d="m.3,14c-0.2-0.2-0.3-0.5-0.3-0.7s0.1-0.5 0.3-0.7l1.4-1.4c0.4-0.4 1-0.4 1.4,0l.1,.1 5.5,5.9c0.2,0.2 0.5,0.2 0.7,0l13.4-13.9h0.1v-8.88178e-16c0.4-0.4 1-0.4 1.4,0l1.4,1.4c0.4,0.4 0.4,1 0,1.4l0,0-16,16.6c-0.2,0.2-0.4,0.3-0.7,0.3-0.3,0-0.5-0.1-0.7-0.3l-7.8-8.4-.2-.3z" fill="#03a9f4"></path>
                    </svg>
                    <svg *ngIf="IsValidedARL === false" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Capa_1_cache3" x="0px" y="0px" viewBox="0 0 174.239 174.239" style="enable-background:new 0 0 174.239 174.239;" xml:space="preserve" width="100%" height="100%" fit="" preserveAspectRatio="xMidYMid meet" focusable="false">
                                        <path style="width: 40px; height: 40px;" d="M146.537,1.047c-1.396-1.396-3.681-1.396-5.077,0L89.658,52.849c-1.396,1.396-3.681,1.396-5.077,0L32.78,1.047  c-1.396-1.396-3.681-1.396-5.077,0L1.047,27.702c-1.396,1.396-1.396,3.681,0,5.077l51.802,51.802c1.396,1.396,1.396,3.681,0,5.077  L1.047,141.46c-1.396,1.396-1.396,3.681,0,5.077l26.655,26.655c1.396,1.396,3.681,1.396,5.077,0l51.802-51.802  c1.396-1.396,3.681-1.396,5.077,0l51.801,51.801c1.396,1.396,3.681,1.396,5.077,0l26.655-26.655c1.396-1.396,1.396-3.681,0-5.077  l-51.801-51.801c-1.396-1.396-1.396-3.681,0-5.077l51.801-51.801c1.396-1.396,1.396-3.681,0-5.077L146.537,1.047z" fill="#D80027"></path>
                      <g>
                                        </g>
                      <g>
                                        </g>
                      <g>
                                        </g>
                      <g>
                                        </g>
                      <g>
                                        </g>
                      <g>
                                        </g>
                      <g>
                                        </g>
                      <g>
                                        </g>
                      <g>
                                        </g>
                      <g>
                                        </g>
                      <g>
                                        </g>
                      <g>
                                        </g>
                      <g>
                                        </g>
                      <g>
                                        </g>
                      <g>
                                        </g>
                                    </svg>
                    <svg *ngIf="IsValidedARL === null" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Capa_1_cache3" x="0px" y="0px" viewBox="0 0 174.239 174.239" style="enable-background:new 0 0 174.239 174.239;" xml:space="preserve" width="100%" height="100%" fit="" preserveAspectRatio="xMidYMid meet" focusable="false">
                                        <path style="width: 40px; height: 40px;" d="M146.537,1.047c-1.396-1.396-3.681-1.396-5.077,0L89.658,52.849c-1.396,1.396-3.681,1.396-5.077,0L32.78,1.047  c-1.396-1.396-3.681-1.396-5.077,0L1.047,27.702c-1.396,1.396-1.396,3.681,0,5.077l51.802,51.802c1.396,1.396,1.396,3.681,0,5.077  L1.047,141.46c-1.396,1.396-1.396,3.681,0,5.077l26.655,26.655c1.396,1.396,3.681,1.396,5.077,0l51.802-51.802  c1.396-1.396,3.681-1.396,5.077,0l51.801,51.801c1.396,1.396,3.681,1.396,5.077,0l26.655-26.655c1.396-1.396,1.396-3.681,0-5.077  l-51.801-51.801c-1.396-1.396-1.396-3.681,0-5.077l51.801-51.801c1.396-1.396,1.396-3.681,0-5.077L146.537,1.047z" fill="#D80027"></path>
                      <g>
                                        </g>
                      <g>
                                        </g>
                      <g>
                                        </g>
                      <g>
                                        </g>
                      <g>
                                        </g>
                      <g>
                                        </g>
                      <g>
                                        </g>
                      <g>
                                        </g>
                      <g>
                                        </g>
                      <g>
                                        </g>
                      <g>
                                        </g>
                      <g>
                                        </g>
                      <g>
                                        </g>
                      <g>
                                        </g>
                      <g>
                                        </g>
                                    </svg>
                    <h3 class="text-description-title">Tipo de riesgo pagado</h3>
                    <app-select-search class="select-component-short"
                                       [appearance]="'outline'"
                                       [_dataSource]="occupationalRisk" [textInput]="''" [dataShow]="'Description'" [dataValue]="'Description'" [siteCtrl]="controOccupationalRisk"
                                       [inputType]="'text'" (onSelectionChange)="changeDateRequirement(socialSecur.Model, socialSecur.Id, null, $event)" [disabled]="socialSecur.Model === undefined || (flagListF === true || flagVeto === true)">
                    </app-select-search>
                  </div>
                </div>

                <div class="item-list-docs" *ngFor="let certif of certification || []" >
                  <div class="doc-name" *ngIf="certifIsValition(certif) === true">
                    <div class="text">
                      <app-img
                        [type]="getshowDocumentos(certif , certif.Model === 'EmployerRequirement' ? 'EmployerRequirement': (certif.DocsJSON !== '{}' && certif.DocsJSON !== '' && certif.DocsJSON !== null ? 'negro': 'rojo'))"
                        [text]="certif.Type"
                        [color]="certif.DocsJSON !== '{}' && certif.DocsJSON !== '' && certif.DocsJSON !== null ? 'negro': 'rojo'"
                        [width]="50"
                        [height]="50"
                        (click)="showDocumentos(certif, 'Certification')"
                        matTooltipPosition="above"
                        [matTooltip]="certif.Desc"
                      ></app-img>

                      <p class="description" *ngIf="certif.Type != 'CCF'">{{certif.Attr || ''}}</p>
                      <!--Select caja de compensacion CCF -->
                      <div class="select-component-medium" *ngIf="certif.Type == 'CCF' && certif.Model !== undefined">
                        <mat-label *ngIf="flagListF === true">{{ccfName || 'CCF'}}</mat-label>
                        <app-select-search *ngIf="flagListF === false" class="select-component-medium"
                                           [appearance]="'outline'"
                                           [_dataSource]="ccf" [textInput]="'CCF'" [dataShow]="'Name'" [dataValue]="'CCFId'" [siteCtrl]="controlCCF"
                                           [inputType]="'text'" (onSelectionChange)="changeCCF($event)" >
                        </app-select-search>
                      </div>
                      <div class="datepikerInput" [ngClass]="getCalculateStateDate(certif.Date, certif.Id)"
                           *ngIf="certif.Model !== 'EmployerRequirement'">
                        <div *ngIf="!this.exitPermissionCompany('personalsrequirements.updatebyposition')">
                          <p><strong style="font-size: 12px; font-weight: bold;">{{certif!.DateLabel || ''}}</strong></p>
                          <p *ngIf="certif.Date != null"  [ngClass]="getCalculateStateDate(getDateDocsUploadIniadoSocialSecurity(certif.Id))+'-string'">{{getDateRequirement(certif.Id) | date:'dd/MM/yyyy' || ''}}</p>
                          <p *ngIf="certif.Date == null" class="DateRed-string">_ _ /_ _ /_ _</p>
                        </div>

                        <mat-form-field class="input-field-medium" [ngClass]="certif.IsDate === true ? 'visibility': 'visibilityhidden'" appearance="outline" *ngIf="this.exitPermissionCompany('personalsrequirements.updatebyposition')">
                          <label><strong>{{certif!.DateLabel || ''}}</strong></label>
                          <input matInput [matDatepicker]="picker" #inputDateCertificado (click)="picker.open()"
                                 (dateChange)="changeDateRequirement(certif.Model, certif.Id, inputDateCertificado.value)"
                                 [value]="certif.Date"
                                 [disabled]="configDisabledDateCertification(certif)">
                          <mat-datepicker #picker></mat-datepicker>
                          <mat-error>Requerido</mat-error>
                        </mat-form-field>
                      </div>
                      <div class="dateTextNodate" *ngIf="certif.Model === 'EmployerRequirement'">{{getDateFormatR(certif?.Date)}}</div>
                    </div>
                  </div>
                </div>
                <div class="item-list-docs" *ngFor="let survey of surveys || []" >
                  <div class="doc-name">
                    <div class="text">
                      <svg  (click)="openDialogDetailsSurveySymptoms(survey.SurveyId)"
                            matTooltipPosition="above"
                            [matTooltip]="survey.Desc"
                            title="EPS" style="fill: #4C4C4C" class="req-abrv" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 27.13 33.91">
                        <path d="M17,0H3.39A3.39,3.39,0,0,0,0,3.39L0,30.52a3.38,3.38,0,0,0,3.37,3.39H23.74a3.4,3.4,0,0,0,3.39-3.39V10.17ZM3.39,30.52V3.39H15.26v8.48h8.48V30.52Z"></path>
                        <text transform="translate(3 22.41)" style="font-size: 11px;" class="uppercase">{{survey.Type}}</text>
                      </svg>
                      <p class="description">{{survey.Attr || ''}}</p>
                      <div class="datepikerInput" [ngClass]="getCalculateStateDate(getDateDocsUploadIniadoSocialSecurity(survey.SurveyId))">
                        <mat-form-field class="input-field-medium" appearance="outline">
                          <label><strong>{{survey!.DateLabel || ''}}</strong></label>
                          <input matInput [matDatepicker]="pickersurvey" #inputDateSurvey (click)="pickersurvey.open()"
                                 (dateChange)="changeDateRequirement(survey.Model, survey.Id, inputDateSurvey.value)"
                                 [value]="getDateRequirement(survey.SurveyId)"
                                 [disabled]="true">
                          <mat-datepicker #pickersurvey></mat-datepicker>
                          <mat-error>Requerido</mat-error>
                        </mat-form-field>
                      </div>
                    </div>
                  </div>

                </div>
                <div class="item-list-docs" *ngFor="let ent of entry || []" >
                  <div class="doc-name">
                    <div class="text">
                      <svg
                        matTooltipPosition="above"
                        [matTooltip]="ent.Desc"
                        title="EPS" style="fill: #4C4C4C" class="req-abrv" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 27.13 33.91">
                        <path d="M17,0H3.39A3.39,3.39,0,0,0,0,3.39L0,30.52a3.38,3.38,0,0,0,3.37,3.39H23.74a3.4,3.4,0,0,0,3.39-3.39V10.17ZM3.39,30.52V3.39H15.26v8.48h8.48V30.52Z"></path>
                        <text transform="translate(3 22.41)" style="font-size: 11px;" class="uppercase">{{ent.Type}}</text>
                      </svg>
                      <p class="description">{{ent.Attr || ''}}</p>
                    </div>
                  </div>

                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>

    <app-card-information *ngIf="!exitPermissionCompany('personalscontracts.view')"
                          [configCard]="{typeCard: 'default', title:'DOCUMENTOS Y REQUISITOS DE ACCESO'}"
                          [notListDescription]="'Aquí se visualizaran los documentos y requisitos de acceso'"
    >
    </app-card-information>

    <!-- CARNETS -->
    <div class="box information-fields" *ngIf="exitPermissionCompany('personalscontracts.view')">
      <div class="header">
        <div class="content" [ngClass]="'greendAnalityco2'">{{'CARNET' || 'N/A'}}</div>
      </div>
      <div class="content-card" *ngIf="exitContractsOffline === true">
        <div class="vigencia-contrat">

          <div class="carmets">
            <div class="subTitle">Empleador: {{employerName}}</div>
            <h3 class="label-carnet"><label>Imprimir carnet</label>
              <button mat-icon-button (click)="printCarnet()" *ngIf="(flagListF === false && flagVeto === false) && exitPermissionCompany('personalscarnets.print') && flagChangeContratista === false"
                      [ngClass]="contractSelected?.IsActive === false || contractSelected?.CarnetCodes === null || contractSelected?.CarnetCodes === '' || contractSelected?.CarnetCodes === '[]' ? 'disabled': ''"
                      [disabled]="contractSelected?.IsActive === false || contractSelected?.CarnetCodes === null || contractSelected?.CarnetCodes === '' || contractSelected?.CarnetCodes === '[]'" color="primary">
                <mat-icon >print</mat-icon>
              </button>
              <button mat-icon-button class="disabled"
                      *ngIf="(flagListF === true || flagVeto === true) || !exitPermissionCompany('personalscarnets.print') || (exitPermissionCompany('personalscarnets.print') && flagChangeContratista === true)"
                      [disabled]="true" color="primary">
                <mat-icon >print</mat-icon>
              </button>
            </h3>

            <h3 class="label-carnet"><label>Generar nuevo carnet</label>
              <button mat-icon-button (click)="generateCarnet()" *ngIf="(flagListF === false && flagVeto === false) && exitPermissionCompany('personalscarnets.generate') && flagChangeContratista === false"
                      [ngClass]="contractSelected?.IsActive === false ? 'disabled': ''"
                      [disabled]="contractSelected?.IsActive === false" color="primary">
                <mat-icon>print</mat-icon>
              </button>
              <button mat-icon-button class="disabled" *ngIf="(flagListF === true || flagVeto === true) || !exitPermissionCompany('personalscarnets.generate')  || (exitPermissionCompany('personalscarnets.print') && flagChangeContratista === true)"
                      [disabled]="true" color="primary">
                <mat-icon >print</mat-icon>
              </button>
            </h3>
          </div>
        </div>
      </div>

      <!-- pre-loading -->
      <div class="content-card list-card pre-content" *ngIf="exitContractsOffline === false">
        <div class="form-group-list" *ngFor="let item of production.pre_loading">
          <div class="card">
            <div class="relational-info">
              <div class="desc flex" style="width: 18px;">
                <div class="icon-pre pre-loading"></div>
                <div class="title-pre pre-loading"></div>
              </div>
              <div class="icon-pre pre-loading"></div>
            </div>
            <div class="card-content">
              <div class="pre-img pre-loading"></div>
              <div class="content-information">
                <div class="text-pre pre-loading"></div>
                <div class="text-pre pre-loading"></div>
                <div class="text-pre pre-loading"></div>
              </div>
            </div>
          </div>
          <hr>
        </div>
      </div>
    </div>
  </div>

</div>





